<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Edit Credit" scrollable hide-footer size="xl">
            <template v-slot:modal-title>
                <span>Edit Credit:</span>
            </template>

            <b-form @submit.stop.prevent="editCredit">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="datepicker-group-date"
                            label="Date:"
                            label-for="datepicker-date"
                            label-size="sm"
                        >
                            <b-form-datepicker
                                :key="keys.datepicker"
                                id="datepicker-date"
                                v-model="credit.date"
                                class="mb-2"
                                size="sm"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                locale="en"
                            >
                            </b-form-datepicker>
                        </b-form-group>

                        <b-form-group
                            id="input-group-customer"
                            label="Customer:"
                            label-for="input-customer"
                            label-size="sm"
                        >
                            <div class="options-assign">
                                <div class="autosuggest-container">
                                    <vue-autosuggest
                                        v-model="credit.customer"
                                        :suggestions="autosuggest.customer.suggestions"
                                        @click="clickHandlerCustomer"
                                        @input="fetchResultsCustomer"
                                        @selected="onSelectedCustomer"
                                        @keydown.tab="suggestFirstCustomer($event.target.value)"
                                        :get-suggestion-value="getSuggestionValueCustomer"
                                        :input-props="{id:'autosuggest__input', placeholder:''}"
                                        @keyup.enter="suggestFirstCustomer($event.target.value)"
                                        @change="customerChanged(0)"
                                    >

                                        <b-container slot-scope="{suggestion}" fluid>
                                            <b-row>
                                                <b-col class="text-right">
                                                    {{ suggestion.item.name }}
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </vue-autosuggest>
                                </div>
                            </div>
                        </b-form-group>

                        <b-form-group
                            id="input-group-amount"
                            label="Amount:"
                            label-for="input-amount"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-amount"
                                v-model="credit.amount"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                                :key="keys.amount"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-reference"
                            label="Reference #:"
                            label-for="input-reference"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-reference"
                                v-model="credit.reference"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-notes"
                            label="Notes:"
                            label-for="input-notes"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-notes"
                                v-model="credit.notes"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="7" class="outstanding-orders">
                        <h6>Balances</h6>
                        <b-table-simple hover small fixed bordered :key="keys.outstanding">
                            <b-thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Ref</th>
                                    <th>Amount</th>
                                    <th>Balance</th>
                                </tr>
                            </b-thead>
                            <b-tbody>
                                <tr v-for="(order, index) in transactions" :key="index">
                                    <td>{{ order.id }}</td>
                                    <td>{{ order.date }}</td>
                                    <td>{{ order.type }}</td>
                                    <td>{{ order.reference_number }}</td>
                                    <td>${{ Number(order.amount).toFixed(2) }}</td>
                                    <td>
                                        <b-link @click="applyBalanceToAmount(order.balance)">${{ Number(order.balance).toFixed(2) }}</b-link>
                                    </td>
                                </tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Modifying Credit...
                            </span>
                            <span v-else>Modify Credit</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest"
	export default {
		props: [
            'customerId',
            'creditInfo'
		],

		components: {
            VueAutosuggest
		},

		data() {
			return {
				modalName: 'modal-lists-customers-edit-credit',
                credit: {
                    applyTo: []
                },
                transactions: [],

                autosuggest: {
                    customer: {
                        suggestions: [],
                        debounceMilliseconds: 500,
                        timeout: null
                    },
                    row: {
                        suggestions: [],
                        debounceMilliseconds: 500,
                        timeout: null,
                        currentIndex: '',
                    }
                },

                keys: {
                    datepicker: 1,
                    outstanding: 1,
                    amount: 1
                },

                customerReset: 0,
                customerUpdated: 0,

                submitting: 0,
			}
		},

		methods: {
            applyBalanceToAmount(balance) {
                this.credit.amount = Number(balance).toFixed(2)
                this.keys.amount++
            },

            clickHandlerCustomer(item) {
                let query = this.credit.customer
                if (!query) {
                    this.autosuggest.customer.suggestions = []
                }
            },

            fetchResultsCustomer() {
                const query = this.credit.customer

                clearTimeout(this.autosuggest.customer.timeout);
                this.autosuggest.customer.timeout = setTimeout(() => {
                    const customersPromise = axios.get('api/lists/customers/getcustomersfilter/' + query);

                    Promise.all([customersPromise]).then(values => {
                        this.autosuggest.customer.suggestions = []

                        const customers = values[0].data.items

                        customers.length &&
                        this.autosuggest.customer.suggestions.push({ name: "customers", data: customers })

                        if (!isNaN(query)) {
                            this.credit.customer = this.autosuggest.customer.suggestions[0].data[0].name
                            this.onSelectedCustomer({item: this.autosuggest.customer.suggestions[0].data[0]})
                        }
                    })
                }, this.autosuggest.customer.debounceMilliseconds)
            },

            onSelectedCustomer(item) {
                if (item) {
                    this.customerReset = 1

                    this.credit.customer = item.item.name
                    this.credit.customerId = item.item.id
                    this.credit.balance = item.item.balance
                    this.credit.open = item.item.open

                    this.customerReset = 0

                    this.getTransactions()

                    this.keys.outstanding++
                }
            },

            suggestFirstCustomer(query) {
                let suggests = this.autosuggest.customer.suggestions
                let arr = suggests[0].data

                if (arr.length) {
                    for (var i = 0; i < arr.length; i++) {
                        let cur = arr[i].name.toLowerCase()
                        if (cur.includes(query.toLowerCase())) {
                            this.customerReset = 1

                            this.credit.customer = arr[i].name
                            this.credit.customerId = arr[i].id
                            this.credit.open = arr[i].open

                            this.autosuggest.customer.suggestions = []

                            this.customerReset = 0

                            this.getTransactions()

                            this.keys.outstanding++

                            break;
                        } else {
                            continue
                        }
                    }
                }
            },

            customerChanged(action) {
                if (this.customerReset == 0) {
                    this.customerUpdated = action
                }
            },

            getSuggestionValueCustomer(suggestion) {
                return suggestion.item.name
            },

            getTransactions() {
                let url = 'api/lists/customers/gettransactions/' + this.credit.customerId
                axios.get(url, {})
                .then((res) => {
                    this.transactions = res.data.transactionsReceivePopup
                }, () => {
                    this.has_error = true
                })
            },

            editCredit() {
                this.submitting = 1
                let formData = this.credit

                let url = 'api/lists/customers/credits/editcredit'
                axios.post(url, {
                    formData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Credit Modified', 'Credit modified successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error modifying credit!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            populateCreditInfo() {
                this.credit.id = this.creditInfo.id

                let now = this.$moment(this.creditInfo.date)
                this.credit.date = now.format('YYYY-MM-DD')
                this.keys.datepicker++

                this.credit.amount = Math.abs(this.creditInfo.amount)
                this.credit.reference = this.creditInfo.reference
                this.credit.notes = this.creditInfo.notes
                this.credit.customer = this.customerId
                this.fetchResultsCustomer()
            }
		},

		computed: {

		},

		mounted() {
            this.populateCreditInfo()
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-edit-credit {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }

        .outstanding-orders {
            border-left: 1px #ccc solid;

            h6 {
                text-align: center;
            }

            table {
                font-size: 10pt;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                width: 100%;

                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }

            #autosuggest { width: 100%; display: block; }

            .autosuggest__results {
                position: relative;
            }

            .autosuggest__results-container {
                width: 300px;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }

            #autosuggest-autosuggest__results {
                overflow-y: hidden;
            }
        }
    }
</style>
